<template>
    <a class="sps-card sps-card--link" :href="card.url" :target="card.openInNewTab === false ? '_self' : '_blank'" rel="noopener noreferrer">
        <span v-if="card.icon" class="sps-card__icon"><img :src="card.icon" :style="iconStyle" alt="" /></span>
        <div class="sps-card__text"><div class="sps-card__title">{{ lc.title }}</div><div v-if="lc.subtitle" class="sps-card__sub">{{ lc.subtitle }}</div></div>
        <span class="sps-card__chevron" aria-hidden="true">↗</span>
    </a>
</template>
<script>
import { mapState } from "vuex";
import { pickLanguageContent } from "../../../../utils/shell/pickLanguageContent";
export default { name: "LinkCard", props: { card: { type: Object, required: true } }, computed: { ...mapState({ defaultLocale: (s) => s.catalog.defaultLocale }), lc() { return pickLanguageContent(this.card.languageContent, this.$i18n.locale, this.defaultLocale) || {}; },
    // ikon kaplama/sigdirma ve odak noktasi; alan yoksa eski davranis (kaplama, orta)
    iconStyle() { const p = this.card.iconPosition || {}; return { objectFit: this.card.iconFit === "contain" ? "contain" : "cover", objectPosition: `${typeof p.x === "number" ? p.x : 50}% ${typeof p.y === "number" ? p.y : 50}%` }; } } };
</script>



// WEBPACK FOOTER //
// src/components/V2/shell/cards/LinkCard.vue